import React from 'react';
import './index.css';
import LazyLoad from 'react-lazyload';
import {Outlet} from 'react-router-dom';
import logo from '../../../assets/images/PERFECT_logo.svg';
import Menu from '../menu';
import WebModule from '../../webmodule';
import CookieStatement from '../cookiestatement';
import Footer from '../Footer';
import pathUtils from '../../../utils/pathUtils';
import {useTranslation} from 'react-i18next';
import classnames from 'classnames';

export default function DefaultLayout() {
  const {i18n} = useTranslation();

  const getLogoLink = () => {
    const url = pathUtils.isEyewear() ? '/business/showcase/online-service/eye-wear/' : '/business/showcase/online-service/';
    return pathUtils.replaceUrlLang(i18n.language, url);
  };

  return (
    <div
      className={classnames({
        'pf-language': true,
        [`pf-language-${i18n.language}`]: true,
        'components-layout-defaultlayout': true,
      })}
    >
      <div>
        <div className="components-layout-defaultlayout__header">
          <div className="components-layout-defaultlayout__logo-container">
            <a href={getLogoLink()} style={{textDecoration: 'none', float: 'left'}}>
              <img alt="logo" src={logo} className={'components-layout-defaultlayout__header-logo'} />
              <div className={'components-layout-defaultlayout__header-logo-text'}> ONLINE SERVICE </div>
            </a>
            <img alt="demo" src={require('../../../assets/images/icons/demo.png')} className="components-layout-defaultlayout__header-demo-logo" />
          </div>
          <Menu />
        </div>
        <CookieStatement />
        <WebModule />
        <div className="components-layout-defaultlayout__body">
          <Outlet />
        </div>
      </div>
      <LazyLoad height={375} once={true}>
        <div className="components-layout-defaultlayout__footer">
          <Footer />
        </div>
      </LazyLoad>
    </div>
  );
}
